import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import './styles/index.css';
import { MsalProvider } from '@azure/msal-react';
import { isAuthBypassed, msalConfig } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

if (isAuthBypassed) {
  // Mock authentication for development
  msalInstance.setActiveAccount({
    homeAccountId: 'mock-home-account-id',
    environment: 'mock-environment',
    tenantId: 'mock-tenant-id',
    username: 'mockuser@domain.com',
    idTokenClaims: {
      name: 'Mock User',
      oid: 'mock-oid',
    },
    localAccountId: '',
  });
}

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);
